import React, { useState, useEffect } from 'react';
import './ProdutoList.css';
import api from '../services/api';
import { toast } from 'react-toastify';
import Pagination from '../components/Pagination';

const PAGE_SIZE = 10;

function SaidaList() {
  const [saidas, setSaidas] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [produto, setProduto] = useState('');
  const [quantidade, setQuantidade] = useState('');
  const [destinatario, setDestinatario] = useState('');
  const [motivo, setMotivo] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('access_token');
      const headers = { Authorization: `Bearer ${token}` };
      try {
        const [saidasRes, produtosRes] = await Promise.all([
          api.get('/saidas/', { headers }),
          api.get('/produtos/', { headers }),
        ]);
        setSaidas(saidasRes.data);
        setProdutos(produtosRes.data);
        if (produtosRes.data.length > 0) setProduto(produtosRes.data[0].id);
      } catch {
        toast.error('Erro ao carregar dados.');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await api.post(
        '/saidas/',
        { produto, quantidade: parseInt(quantidade, 10), destinatario, motivo },
        { headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}`, 'Content-Type': 'application/json' } }
      );
      setSaidas([res.data, ...saidas]);
      setQuantidade('');
      setDestinatario('');
      setMotivo('');
      toast.success('Saída registrada com sucesso!');
    } catch (err) {
      const msg =
        err.response?.data?.quantidade?.[0] ||
        err.response?.data?.detail ||
        'Erro ao registrar saída.';
      toast.error(msg);
    } finally {
      setSaving(false);
    }
  };

  const nomeProduto = (id) => {
    const p = produtos.find((p) => p.id === id);
    return p ? p.nome : '—';
  };

  const formatDate = (str) => {
    if (!str) return '—';
    return new Date(str).toLocaleDateString('pt-BR');
  };

  const filteredSaidas = saidas.filter((s) => {
    const q = search.toLowerCase();
    return nomeProduto(s.produto).toLowerCase().includes(q) ||
      s.destinatario.toLowerCase().includes(q);
  });
  const totalPages = Math.ceil(filteredSaidas.length / PAGE_SIZE);
  const paginated  = filteredSaidas.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <div className="produto-page">

      {/* Header */}
      <div className="produto-page-header">
        <div className="produto-page-title-row">
          <h2 className="produto-page-title">Saídas de Estoque</h2>
        </div>
      </div>

      {/* Form card */}
      <div className="prd-card prd-form-card">
        <div className="prd-card-accent" />
        <div className="prd-form-body">
          <header className="prd-form-header">
            <h3 className="prd-form-title">Registrar Nova Saída</h3>
            <p className="prd-form-sub">Informe o produto, quantidade e destinatário para registrar a saída do estoque.</p>
          </header>

          <form onSubmit={handleSubmit}>
            <div className="prd-form-left">
              <div className="prd-form-row3" style={{ gridTemplateColumns: '1fr 140px 1fr' }}>
                <div className="prd-field">
                  <label className="prd-label">Produto</label>
                  <select
                    className="prd-input"
                    value={produto}
                    onChange={(e) => setProduto(e.target.value)}
                    required
                  >
                    {produtos.map((p) => (
                      <option key={p.id} value={p.id}>{p.nome}</option>
                    ))}
                  </select>
                </div>

                <div className="prd-field">
                  <label className="prd-label">Quantidade</label>
                  <input
                    className="prd-input"
                    type="number"
                    min="1"
                    placeholder="0"
                    value={quantidade}
                    onChange={(e) => setQuantidade(e.target.value)}
                    required
                  />
                </div>

                <div className="prd-field">
                  <label className="prd-label">Destinatário</label>
                  <input
                    className="prd-input"
                    type="text"
                    placeholder="Nome do cliente ou destino"
                    value={destinatario}
                    onChange={(e) => setDestinatario(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="prd-field prd-field--full">
                <label className="prd-label">Motivo (opcional)</label>
                <input
                  className="prd-input"
                  type="text"
                  placeholder="Ex: Venda, devolução, transferência..."
                  value={motivo}
                  onChange={(e) => setMotivo(e.target.value)}
                />
              </div>
            </div>

            <div className="prd-form-actions" style={{ gridColumn: 'unset', marginTop: '1.5rem' }}>
              <button type="submit" className="prd-btn-save" disabled={saving || produtos.length === 0}
                style={{ background: '#ba1a1a', boxShadow: '0 4px 12px rgba(186,26,26,0.25)' }}>
                <span className="material-symbols-outlined">arrow_circle_up</span>
                {saving ? 'Registrando...' : 'Registrar Saída'}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* History table */}
      <div className="prd-card prd-table-card">
        <div className="prd-card-accent" style={{ background: '#ba1a1a' }} />
        <div className="prd-table-toolbar">
          <span className="prd-table-count">Histórico de Saídas</span>
          <div className="produto-search-wrap" style={{ maxWidth: 260 }}>
            <span className="material-symbols-outlined">search</span>
            <input
              type="text"
              placeholder="Buscar produto ou destinatário..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
        <div className="prd-table-wrap">
          <table className="prd-table">
            <thead>
              <tr>
                <th>Produto</th>
                <th className="center">Quantidade</th>
                <th>Destinatário</th>
                <th>Motivo</th>
                <th>Data</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: 4 }).map((_, i) => (
                  <tr key={i}>
                    {Array.from({ length: 5 }).map((__, j) => (
                      <td key={j}><div className="skeleton" /></td>
                    ))}
                  </tr>
                ))
              ) : saidas.length === 0 ? (
                <tr>
                  <td colSpan={5} className="prd-empty">Nenhuma saída registrada.</td>
                </tr>
              ) : (
                paginated.map((saida) => (
                  <tr key={saida.id}>
                    <td>
                      <div className="td-name-wrap">
                        <div className="td-thumb" style={{ background: '#ffdad6', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <span className="material-symbols-outlined" style={{ fontSize: '16px', color: '#ba1a1a' }}>arrow_circle_up</span>
                        </div>
                        <span className="td-name">{nomeProduto(saida.produto)}</span>
                      </div>
                    </td>
                    <td className="center td-stock">{saida.quantidade}</td>
                    <td>{saida.destinatario}</td>
                    <td>{saida.motivo || '—'}</td>
                    <td>{formatDate(saida.data_saida)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <Pagination page={page} totalPages={totalPages} onPageChange={(p) => { setPage(p); window.scrollTo(0, 0); }} />
      </div>
    </div>
  );
}

export default SaidaList;
